<template>
  <div :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="8">
            <a-form-item :label="$t(I18N_KEY + 'taskName')">
              <a-input :placeholder="$t('enter') + ' ' + $t(I18N_KEY + 'taskName')" v-model="queryParam.taskName" :allowClear='allowClear'></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="$t(I18N_KEY + 'taskChannel')">
              <a-select v-model="queryParam.channel" :placeholder="$t('select')" style="width: 100%" :allowClear='allowClear'>
                <a-select-option value="">{{ $t(I18N_KEY+'all') }}</a-select-option>
                <a-select-option v-for='item in channels' :key='item'>
                  {{item}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="$t(I18N_KEY + 'taskStatus')">
              <a-select v-model="queryParam.status" :placeholder="$t('select')" style="width: 100%" :allowClear='allowClear'>
                <a-select-option value="">{{ $t(I18N_KEY+'all') }}</a-select-option>
                <a-select-option v-for='item in statuses' :key='item.value'>
                  {{item[fieldName]}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :md="8" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('search') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('reset') }}</a-button>
              <a-button type="primary" @click="handleAdd" icon="plus" style="margin-left: 8px">{{ $t('add') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
      <a-table
        ref="table"
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        :scroll="{ x: 1500 }"
        bordered>
         <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{ $t('edit') }}</a>
           <a-divider type="vertical" />
           <a-dropdown>
          <a class="ant-dropdown-link">
          {{ $t('more') }} <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item>
              <a-popconfirm :title="$t('confirmDelete')" @confirm="() => deleteCurrent(record)">
                <a>{{ $t('delete') }}</a>
              </a-popconfirm>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
<!--          <a @click="taskList(record)" >{{ $t(I18N_KEY + 'taskList') }}</a>-->
        </span>
      </a-table>
      <div style="margin-top: 15px; text-align: right;">
        <v-pagination
          v-if="total"
          :page-num="queryParam.pageNum"
          :page-size="queryParam.pageSize"
          :total="total"
          @change="handleTableChange" />
      </div>
      <tele-market-third-task-config-edit ref="modalForm" :channels='channels' :statuses='statuses' :convert-not-calls='convertNotCalls' :field-name='fieldName' @ok="modalFormOk"></tele-market-third-task-config-edit>
    </div>
  </div>
</template>
<script>
import { taskListPre, taskConfigList, taskConfigOpt } from '@/webpublicapi/teleMarket'
import {mapGetters} from "vuex";
import { filterObj } from '@/utils/util'
import moment from 'moment/moment'
import TeleMarketThirdTaskConfigEdit from './modules/TeleMarketThirdTaskConfigEdit'
const I18N_KEY = 'teleMarket.';
export default {
  name: 'TeleMarketThirdTask',
  components: {
    TeleMarketThirdTaskConfigEdit,
  },
  data () {
    return {
      I18N_KEY,
      loading: false,
      allowClear: true,
      total: 0,
      channels: [],
      statuses: [],
      convertNotCalls: [0,1],
      fieldName: 'textCn',
      queryParam: {
        pageNum: 1,
        pageSize: 30,
        taskName: '',
        channel: '',
        status: ''
      },
      visible: false,
      dataSource: [],
      configId: null,
      taskId: null,
    }
  },
  computed: {
    ...mapGetters('language', ['languageStorage']),
    // Table header
    columns () {
      return [
        {
          title: this.$t(I18N_KEY + 'id'),
          dataIndex: 'id',
          align:"center",
          width:80,
        },
        {
          title: this.$t(I18N_KEY + 'taskName'),
          dataIndex: 'taskName',
          width:100,
          align:"center",
        },
        {
          title: this.$t(I18N_KEY + 'taskChannel'),
          align: 'center',
          width: 100,
          dataIndex: 'channel',
        },
        {
          title: this.$t(I18N_KEY + 'taskStatus'),
          dataIndex: 'status',
          align:"center",
          width:100,
          customRender: (text, record) => {
            var text = text;
            if(text != undefined && text != null && text != '') {
              for(var i in this.statuses) {
                if(text === this.statuses[i].value) {
                  return this.statuses[i][this.fieldName]
                }
              }
            } else {
              return '';
            }
          },
        },
        {
          title: this.$t(I18N_KEY + 'strategyId'),
          align: 'center',
          dataIndex: 'strategyId',
          width:150,
        },
        {
          title: this.$t(I18N_KEY + 'thirdTaskId'),
          align:"center",
          dataIndex: 'thirdTaskId',
          width:100,
        },
        {
          title: this.$t(I18N_KEY + 'connectNotCall'),
          align:"center",
          dataIndex: 'connectNotCall',
          width:120,
        },
        {
          title: this.$t(I18N_KEY + 'convertNotCall'),
          align:"center",
          dataIndex: 'convertNotCall',
          width:100,
          customRender: (text, record) => {
            var text = text;
            if(text != undefined && text != null && text != '') {
              return this.$t(I18N_KEY + 'convertNotCall_'+text)
            } else {
              return '';
            }
          },
        },
        {
          title: this.$t(I18N_KEY + 'accessKeys'),
          align:"center",
          dataIndex: 'accessKeys',
          width:200,
          ellipsis: true,
        },
        {
          title: this.$t(I18N_KEY + 'taskIds'),
          align:"center",
          dataIndex: 'taskIds',
          width:150,
        },
        {
          title: this.$t(I18N_KEY + 'createTime'),
          align:"center",
          width:170,
          dataIndex: 'createTime',
        },
        {
          title: this.$t(I18N_KEY + 'updateTime'),
          align:"center",
          width:170,
          dataIndex: 'updateTime',
        },
        {
          title: this.$t('action'),
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 180,
          scopedSlots: { customRender: 'action' }
        }]
    },
  },
  created () {
    this.loadBaseData();
    this.loadData('');
  },
  methods: {
    loadBaseData(){
      taskListPre({}).then((res) => {
        if (res.code === 1000) {
          this.channels = res.data.channels
          this.statuses = res.data.commonStatuses
        } else {
          this.$message.error(res.msg)
        }
      }).catch(e => {
        this.$message.error(e.message);
      })
    },
    searchQuery () {
      this.loadData(1)
    },
    handleTableChange (pageNum, pageSize) {
      this.queryParam.pageNum = pageNum;
      this.queryParam.pageSize = pageSize;
      this.loadData();
    },
    handleAdd () {
      this.configId = undefined;
      this.taskId = undefined;
      this.$refs.modalForm.add();
      this.$refs.modalForm.title = "1";
      this.$refs.modalForm.disableSubmit = false;
    },
    handleEdit (record) {
      this.configId = record.id;
      this.taskId = record.taskId;
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = "2";
      this.$refs.modalForm.disableSubmit = false;
    },
    changeModal (visible) {
      this.visible = visible;
    },
    searchReset () {
      // this.createdTime = []
      this.queryParam.pageNum=1
      this.queryParam.pageSize=10
      this.queryParam.taskName=''
      this.queryParam.channel=''
      this.queryParam.status=''
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    getQueryParams() {
      const { createdTime } = this.queryParam;
      const data = {
        ...this.queryParam,
      }
      var param = Object.assign({}, data)
      return filterObj(param)
    },
    loadData (pageNum) {
      if(pageNum) { this.queryParam.pageNum = pageNum; }
      this.loading = true;
      var params = this.getQueryParams()// Query conditions
      taskConfigList(Object.assign({}, params)).then(res => {
        this.loading = false;
        this.total = res.data.total
        this.dataSource = res.data.rows;
      }).catch(e => {
        this.loading = false;
        this.$message.error(e.message);
      });
    },
    statusText(status) {
      for(var i in this.statuses) {
        if(status === this.statuses[i].value) {
          return this.statuses[i][this.fieldName]
        }
      }
    },
    deleteCurrent(data) {
      this.loading = true;
      const form = {
        id: data.id,
        taskId: data.taskId,
        opt: '3',
      };
      this.opt(form)
    },
    modalFormOk (data) {
      console.log(data)
      const form = {
        ...data,
        id: this.configId,
        taskId: this.taskId,
        opt: this.configId ? '2' : '1',
      };
      this.opt(form);
      // const requestField = this.versionId ? '2' : '1'
      // taskConfigOpt(form).then(res => {
      //   this.$refs.modalForm.closeLoading();
      //   this.$refs.modalForm.close();
      //   if (res.code === 1000) {
      //     this.$message.success(res.msg);
      //     this.loadData(1);
      //   } else {
      //     this.$message.error(res.msg);
      //   }
      // }).catch(e => {
      //   this.$refs.modalForm.closeLoading();
      //   this.$message.error(e.message);
      // })
    },
    opt(form) {
      taskConfigOpt(form).then(res => {
        this.$refs.modalForm.closeLoading();
        this.$refs.modalForm.close();
        if (res.code === 1000) {
          this.$message.success(res.msg);
          this.loadData(1);
        } else {
          this.$message.error(res.msg);
        }
      }).catch(e => {
        this.$refs.modalForm.closeLoading();
        this.$message.error(e.message);
      })
    },
  },

  watch: {
    languageStorage: {
      handler (lang) {
        if (lang == 'en-US') {
          this.fieldName = 'textEn';
        } else if (lang == 'es') {
          this.fieldName = 'textEs';
        } else {
          this.fieldName = 'textEn';
        }
      },
      immediate: true,
    }
  },
}
</script>
<style scoped>
@import '~@/assets/less/common.less';
</style>
